import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { put } from '../modules/user'

import component from 'components/Users/Account'

const mapActionCreators = {
  onSubmit: put
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => {
  let obj = {
    user: state.user,
    isAdmin: state.auth && state.auth.isAdmin,
    initialValues: state.user
  }

  let ccOrders = obj.user.customers &&
    obj.user.customers.filter(c => c.cc_orders)
      .map(c => c.cc_orders.split(',').map(s => s && s.trim()))
      .flatten().filter(o => o) ||
      []
  if (ccOrders.length) obj.initialValues.cc_orders = [...new Set(ccOrders)].join(', ')

  return obj
}

const form = reduxForm({
  form: 'edit-user',
  fields: ['id', 'email', 'timezone', 'rollover_offset', 'password', 'cc_orders', 'send_order_confirmations'],
  touchOnChange: true,
  validate (state) {
    var errors = {}

    if (state.password && state.password.length < 6) {
      errors.password = 'Your password must be at least 6 characters long.'
    }

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Users/containers/AccountContainer.js